import React, { useContext, useState, useEffect } from "react";
import InternalPageHeader from "../../components/media/InternalPageHeader";
import ArticleText from "../../components/text/ArticleText";
import ImgTextCardTyler from "../../components/media/ImgTextCardTyler";
import bgInternalImage from "../../images/Smathers-Grand-Reading-Room-Zoom-Background-2752x1392.jpg";
import Footer from "../../components/Footer";
import { Container, Row, Col, Accordion } from "react-bootstrap";
import ListGroup from "react-bootstrap/ListGroup";
import { traumaInformedContext } from "../../contexts/TraumaInformedContext";
import { Skeleton } from "@mui/material";

const TraumaInformedResources = () => {
  const { traumaInformedData, loading } = useContext(traumaInformedContext);
  const [traumaInformedTools, setTraumaInformedTools] = useState([]);
  const [traumaInformedReadings, setTraumaInformedLearnings] = useState([]);
  const [traumaInformedCurriculum, setTraumaInformedCurriculum] = useState([]);
  const [isTraumaDataLoading, setIsTraumaDataLoading] = useState(true);

  const TraumaDataSkeletonTiles = Array.from({ length: 3 }).map((_, index) => (
    <Col
      xs={12}
      sm={12}
      md={6}
      lg={4}
      xl={4}
      style={{
        textAlign: "center",
        color: "#00283C",
        padding: "1%",
     
      }}
      key={index}
    >
      <div
        style={{
          borderRadius: "3%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          padding: "6%",
          background: "#FAFAFA",
          height: "100px",
          boxShadow: "1px 2px 6px rgba(0, 0, 0, 0.25)",
          marginLeft: "10px",
          marginRight: "10px",
          
        }}
      >
        <Skeleton variant="text" animation="wave" height={20} width="80%" />
        <Skeleton
          variant="text"
          animation="wave"
          height={20}
          width="60%"
          style={{ marginTop: 8 }}
        />
      </div>
    </Col>
  ));

  useEffect(() => {
    if (traumaInformedData) {
      processTraumaInformedData();
    }
  }, [traumaInformedData, loading]);

  const processTraumaInformedData = () => {
    const tIData = traumaInformedData;
    const traumaInformedToolsData = tIData.filter(
      (item) => item.InformedResourceGroupName === "Tools"
    );
    const traumaInformedReadingsData = tIData.filter(
      (item) => item.InformedResourceGroupName === "Readings"
    );
    const traumaInformedCurriculumData = tIData.filter(
      (item) => item.InformedResourceGroupName === "Curriculum"
    );

    const traumaInformedTools = traumaInformedToolsData.map((file) => (
      <Col
        xs={12}
        sm={12}
        md={6}
        lg={4}
        xl={4}
        style={{ textAlign: "center", color: "#00283C", padding: "1%" }}
        key={file.id}
      >
        <a
          className="hoverState"
          style={{ color: "#00283C", textDecoration: "underline" }}
          href={
            file.link
              ? file.link
              : `${process.env.PUBLIC_URL}${encodeURI(
                  "/files/tools/" + file.resourcepath
                )}`
          }
          target="_blank"
          rel="noreferrer"
        >
          <ListGroup variant="flush">
            <ImgTextCardTyler siteName={file.Title} siteAddress={file.Date} />
          </ListGroup>
        </a>
      </Col>
    ));
    const traumaInformedReadings = traumaInformedReadingsData.map((file) => (
      <Col
        xs={12}
        sm={12}
        md={6}
        lg={4}
        xl={4}
        style={{ textAlign: "center", color: "#00283C", padding: "1%" }}
        key={file.id}
      >
        <a
          className="hoverState"
          style={{ color: "#00283C", textDecoration: "underline" }}
          href={
            file.link
              ? file.link
              : `${process.env.PUBLIC_URL}${encodeURI(
                  "/files/readings/" + file.resourcepath
                )}`
          }
          target="_blank"
          rel="noreferrer"
        >
          <ListGroup variant="flush">
            <ImgTextCardTyler siteName={file.Title} siteAddress={file.Date} />
          </ListGroup>
        </a>
      </Col>
    ));
    const traumaInformedCurriculum = traumaInformedCurriculumData.map(
      (file) => (
        <Col
          xs={12}
          sm={12}
          md={6}
          lg={4}
          xl={4}
          style={{ textAlign: "center", color: "#00283C", padding: "1%" }}
          key={file.id}
        >
          <a
            className="hoverState"
            style={{ color: "#00283C", textDecoration: "underline" }}
            href={
              file.link
                ? file.link
                : `${process.env.PUBLIC_URL}${encodeURI(
                    "/files/curriculum/" + file.resourcepath
                  )}`
            }
            target="_blank"
            rel="noreferrer"
          >
            <ListGroup variant="flush">
              <ImgTextCardTyler siteName={file.Title} siteAddress={file.Date} />
            </ListGroup>
          </a>
        </Col>
      )
    );
    setTraumaInformedTools(traumaInformedTools);
    setTraumaInformedLearnings(traumaInformedReadings);
    setTraumaInformedCurriculum(traumaInformedCurriculum);
    setIsTraumaDataLoading(false);

    // console.log("Got T data to T component");
  };

  return (
    <main className="traumaInformed" id="tools" >
      <InternalPageHeader
        pageHeading={"Trauma-Informed Resources"}
        pageSubHeading={"Important Readings & Tools"}
        inPageBGImage={bgInternalImage}
 
        
      />
      <a
  style={{
    position: "fixed",
    bottom: '80px',
        right: '14px',
    color: "white",
    zIndex: 999,
  }}
  href="#tools"
  aria-label="Back to the Top of the Page Button"
>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="50"
    height="50"
    fill="#E6C200"
    className="bi bi-arrow-up-circle-fill"
    viewBox="0 0 16 16"
    aria-hidden="true"
    focusable="false"
  >
    <path d="M16 8A8 8 0 1 0 0 8a8 8 0 0 0 16 0m-7.5 3.5a.5.5 0 0 1-1 0V5.707L5.354 7.854a.5.5 0 1 1-.708-.708l3-3a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 5.707z" />
  </svg>
</a>
<Container className='trauma-container'>
  <Row>
    <Col xs={12} >
      <ArticleText
     
        articleText={`When dealing with difficult histories, it is crucial to remember the importance of one’s well-being. Anyone who approaches these histories must prioritize their mental health by taking the necessary precautions to ensure their emotional safety and well-being before engaging the subject.`}
      />
      <ArticleText
        articleText={`Below is a list of potential resources to use in preparation for this website’s content, or for when the material on this website becomes too overwhelming. Please remember throughout the process that it is normal to experience a wide range of emotions (e.g., shame, anger, sadness, etc.) when engaging with this material.`}
      />
      <ArticleText
        articleText={`We understand that everyone has their own preferred way of coping and destressing and, therefore, recognize that this list will not aid everyone the same way. There is no one, or ‘right’ way to heal after a traumatic event. There is also no one right way to take care of yourself. The following resources are meant to provide a starting point for anyone who seeks to know more about approaches to difficult histories of racial injustice and trauma-informed mindfulness exercises. This list is not exhaustive and is not meant to be seen as the only resources available.`}
      />
      </Col>
      </Row>
</Container>
      <Container className="tools">
        <Row>
          <Col sm={12}>
            <Accordion defaultActiveKey={["0"]} alwaysOpen="true">
              <Accordion.Item eventKey="0">
                <Accordion.Header
                  style={{ textDecoration: "underline", width: "100%" }}
                >
                  {" "}
                  <Row>
                    <Col style={{ width: "100%" }} sm={12}>
                      <h3>Tools</h3>
                    </Col>
                  </Row>{" "}
                  <hr></hr>{" "}
                </Accordion.Header>
                <Accordion.Body>
                  <Row>
                    <ArticleText
                      articleText={`Below you will find a list of tools to aid in your journey with this difficult piece of U.S. history. From meditative practices to learning resources, these tools represent a wide range of aids in the realm of difficult histories. As mentioned, this list is not exhaustive but instead meant to provide examples of helpful strategies.`}
                    />
                  </Row>
                  <Row>
                    {isTraumaDataLoading
                      ? TraumaDataSkeletonTiles
                      : traumaInformedTools}
                  </Row>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </Col>
        </Row>
      </Container>

      <Container className="readings">
        <Row>
          <Col sm={12} backgroundColor="purple">
            <Accordion defaultActiveKey={["0"]} alwaysOpen="true">
              <Accordion.Item eventKey="0">
                <Accordion.Header
                  style={{ textDecoration: "underline", width: "100%" }}
                >
                  {" "}
                  <Row>
                    <Col
                      style={{ textDecoration: "underline", width: "100%" }}
                      sm={12}
                    ></Col>
                    <h3>Readings</h3>
                  </Row>{" "}
                </Accordion.Header>
                <Accordion.Body>
                  <Row>
                    <ArticleText
                      articleText={`Many reading lists exist on the topics of difficult histories, racial trauma, racial terror lynchings, enslavement, etc. Below is a curated selection of some of those readings:`}
                    />
                  </Row>
                  <Row>
                    <Row>
                      {isTraumaDataLoading
                        ? TraumaDataSkeletonTiles
                        : traumaInformedReadings}
                    </Row>
                  </Row>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </Col>
        </Row>
      </Container>

      <Container className="curriculum">
        <Row>
          <Col sm={12}>
            <Accordion defaultActiveKey={["0"]} alwaysOpen="true">
              <Accordion.Item eventKey="0">
                <Accordion.Header
                  style={{ textDecoration: "underline", width: "100%" }}
                >
                  {" "}
                  <Row>
                    <Col style={{ width: "100%" }} sm={12}>
                      <h3>Curriculum</h3>{" "}
                    </Col>
                  </Row>{" "}
                </Accordion.Header>
                <Accordion.Body>
                  <Row>
                    <ArticleText
                      articleText={`The Alachua County Community Remembrance Project and its partners have developed curriculum plans with a variety of intentions and applications. There are distinct lesson plans for upper-grade levels, as well as curriculum resources for adults. ACCRP would like to extend a special thank you to the University of Florida’s Social Studies Education Program for the generous use of their curriculum.`}
                    />
                  </Row>
                  <Row>
                    {isTraumaDataLoading
                      ? TraumaDataSkeletonTiles
                      : traumaInformedCurriculum}
                  </Row>
                  <Row>
                    <ArticleText
                      articleText={`Please note that these curricula relate to difficult heritage topics, namely racial terror and lynchings. These materials will inevitably evoke a personal response and, therefore, it is important to be aware that our responses to certain materials may prove to be unsettling or challenging to come to terms with. For example, some of the following curricula include images of lynchings as evidence of the crimes committed against Black citizens during this period of racial terror and violence. Please be advised before accessing the following curricula that these images may cause difficult emotions for educators and students alike; they may even trigger previous experiences of trauma. We encourage teachers and educators to reflect upon the power imbalances embedded within these images, how they were taken, and for what purposes. It may not be the best practice to continue to show them if the only goal is to shock. We also encourage students to be allowed to shape this conversation and in decision-making process prior to their usage.`}
                    />
                  </Row>
                  <div className="articleText">
                    <Container>
                      <Row>
                        <Col className="hold-article">
                          <p className="articleText">
                            For other historical resources, the Library of
                            Congress offers access to state and local newspapers
                            from the era. Florida’s can be found here:
                            <a
                              style={{ textDecoration: "underline" }}
                              className="hyperlinks"
                              href="https://chroniclingamerica.loc.gov/newspapers/florida/"
                              target="_blank"
                              rel="noreferrer"
                            >
                              Digitized Florida Newspapers
                            </a>
                            .
                          </p>
                        </Col>
                      </Row>
                    </Container>
                  </div>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </Col>
        </Row>
      </Container>
      <Container className="addMarginArchivePg">
        <Row>{loading && <p style={{ color: "#FFFFFF" }}> Loading...</p>}</Row>
      </Container>
      <Footer />
    </main>
  );
};

export default TraumaInformedResources;
